import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { handleGetSharedInquiryResponse, handleShareInquiryResponse } from './actions';
import { IInquiriesShareState } from './slice.interface';

const initialState: IInquiriesShareState = {
  shareInquiryId: null,
  shareSelectedSupplements: [],
  shareUrl: null,
  sharedResponse: null,
  isLoading: false,
  error: false,
};

export const inquiriesShareSlice = createSlice({
  name: 'inquiries-share',
  initialState,
  reducers: {
    setShareInquiryId: (state: IInquiriesShareState, action: PayloadAction<number | null>) => {
      state.shareInquiryId = action.payload;
    },

    setShareSelectedSupplements: (state: IInquiriesShareState, action: PayloadAction<number[]>) => {
      state.shareSelectedSupplements = action.payload;
    },

    removeSharedInquiryResponseDetails: (state: IInquiriesShareState) => {
      state.shareInquiryId = null;
      state.shareSelectedSupplements = [];
      state.sharedResponse = null;
      state.shareUrl = null;
      state.isLoading = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleShareInquiryResponse.pending, (state: IInquiriesShareState, action) => {
        state.shareInquiryId = action.meta.arg.inquiryId;
        state.shareUrl = null;
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleShareInquiryResponse.rejected, (state: IInquiriesShareState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleShareInquiryResponse.fulfilled, (state: IInquiriesShareState, action) => {
        state.shareUrl = action.payload.data.sharedInquiryUrl;
        state.isLoading = false;
      })
      .addCase(handleGetSharedInquiryResponse.pending, (state: IInquiriesShareState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetSharedInquiryResponse.rejected, (state: IInquiriesShareState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetSharedInquiryResponse.fulfilled, (state: IInquiriesShareState, action) => {
        state.sharedResponse = action.payload.data;
        state.isLoading = false;
      });
  },
});

export const {
  setShareInquiryId,
  setShareSelectedSupplements,
  removeSharedInquiryResponseDetails,
} = inquiriesShareSlice.actions;

export default inquiriesShareSlice.reducer;
